import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const steps = [
  {
    number: '01',
    icon: 'ri-shopping-bag-2-line',
    title: 'Elige tu talla',
    description:
      'Usa nuestro medidor de talla gratuito o selecciona tu número. El kit incluye 3 tallas para asegurar el ajuste perfecto.',
    detail: 'Kit de tallas incluido',
  },
  {
    number: '02',
    icon: 'ri-bluetooth-connect-line',
    title: 'Vincúlalo a tu móvil',
    description:
      'Descarga la app HELIX, activa el Bluetooth y empareja en segundos. Compatible con iOS y Android. Sin configuraciones complejas.',
    detail: 'Configuración en &lt; 2 min',
  },
  {
    number: '03',
    icon: 'ri-line-chart-line',
    title: 'Descubre tus datos',
    description:
      'Desde el primer día tendrás métricas detalladas de salud, alertas personalizadas y recomendaciones adaptadas a ti.',
    detail: 'Insights desde el día 1',
  },
];

const HowItWorksSection = () => {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation();
  const { ref: stepsRef, isVisible: stepsVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section id="como-funciona" className="py-28 w-full" style={{ backgroundColor: '#f9f8f6' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div
          ref={titleRef}
          className={`max-w-2xl mb-20 scroll-hidden ${titleVisible ? 'scroll-visible' : ''}`}
        >
          <span className="font-body text-xs font-semibold tracking-widest text-amber-700 uppercase block mb-4">
            Inicio rápido
          </span>
          <h2 className="font-display text-4xl lg:text-5xl font-light text-stone-900 leading-tight mb-5">
            Tres pasos.
            <br />
            <em className="not-italic font-semibold">Listo para siempre.</em>
          </h2>
          <p className="font-body text-stone-500 text-base leading-relaxed">
            HELIX está diseñado para que empieces a obtener valor desde el primer
            momento. Sin manuales. Sin frustraciones.
          </p>
        </div>

        {/* Steps */}
        <div ref={stepsRef} className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-6 relative">
          {/* Connecting line (desktop) */}
          <div className="hidden lg:block absolute top-16 left-1/6 right-1/6 h-px bg-gradient-to-r from-transparent via-amber-300 to-transparent" />

          {steps.map((step, i) => (
            <div
              key={step.number}
              className={`relative scroll-hidden ${stepsVisible ? 'scroll-visible' : ''}`}
              style={{ transitionDelay: stepsVisible ? `${i * 0.15}s` : '0s' }}
            >
              {/* Step number */}
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-stone-900 text-white flex-shrink-0">
                  <span className="font-body text-xs font-bold tracking-widest">{step.number}</span>
                </div>
                <div className="h-px flex-1 bg-stone-200" />
              </div>

              {/* Icon */}
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-white border border-stone-100 mb-6">
                <i className={`${step.icon} text-2xl text-amber-700`} />
              </div>

              {/* Content */}
              <h3 className="font-display text-2xl font-semibold text-stone-900 mb-3">
                {step.title}
              </h3>
              <p className="font-body text-stone-500 text-sm leading-relaxed mb-5">
                {step.description}
              </p>

              {/* Detail badge */}
              <span
                className="inline-flex items-center gap-1.5 bg-amber-50 text-amber-800 font-body text-xs font-medium px-3 py-1.5 rounded-full border border-amber-200"
                dangerouslySetInnerHTML={{ __html: step.detail }}
              />
            </div>
          ))}
        </div>

        {/* App preview strip */}
        <div className={`mt-24 rounded-3xl overflow-hidden relative scroll-hidden ${titleVisible ? 'scroll-visible delay-300' : ''}`}>
          <img
            src="https://public.readdy.ai/ai/img_res/c508d9180038fc0f44734b2dd07c03b3.jpg"
            alt="App HELIX Ring dashboard de salud"
            className="w-full object-cover object-center"
            style={{ height: '280px' }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-stone-900/70 via-transparent to-stone-900/70" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center text-white">
              <h4 className="font-display text-3xl font-light mb-2">
                Tu salud, visualizada con elegancia
              </h4>
              <p className="font-body text-sm text-white/60">
                App disponible para iOS &amp; Android · Sincronización instantánea
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
